module.exports = __webpack_public_path__ + "static/media/empty.81005430.svg";